import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { Calendar, CheckCircle, Clock, Power } from "lucide-react";
import React from "react";
import { useDisconnectionSummary } from "../../hooks";

export const Summary: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: summaryData } = useDisconnectionSummary({
    remoteUtilityId: Number(remoteUtilityId),
    requestType: "Disconnect Permanent",
  });

  console.log("summaryData", summaryData);

  const summaryCards = [
    {
      title: "Pending Disconnections",
      tooltip: 'Disconnection requests that are logged but not yet completed.',
      value: summaryData?.pendingCount,
      // change: `${summaryData?.pendingCount} from yesterday`,
      trend: "up" as const,
      icon: <Clock className="h-8 w-8 text-orange-500" />,
      color: "text-orange-600",
    },
    {
      title: "Completed",
      tooltip: 'Disconnection requests successfully processed and closed.',
      value: summaryData?.completedCount,
      // change: `${summaryData?.completedCount} from yesterday`,
      trend: "down" as const,
      icon: <Calendar className="h-8 w-8 text-blue-500" />,
      color: "text-blue-600",
    },
    {
      title: "Avg Processing Time",
      tooltip: 'Average time taken to process disconnection requests.',
      value: summaryData?.averageProcessingDays,
      // change: `${summaryData?.rejectedCount} from yesterday`,
      trend: "up" as const,
      icon: <Power className="h-8 w-8 text-purple-500" />,
      color: "text-purple-600",
    },
    {
      title: "Rejected ",
      tooltip: 'Disconnection requests that were declined or not approved.',
      value: summaryData?.rejectedCount,
      // change: `${summaryData?.completedCount} from yesterday`,
      trend: "up" as const,
      icon: <CheckCircle className="h-8 w-8 text-green-500" />,
      color: "text-green-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {summaryCards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.value}
          trendDirection={card.trend}
          // trendSummary={card.change}
          icon={card.icon}
          tooltip={card.tooltip}
        />
      ))}
    </div>
  );
};
